<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">{{
                $t("sectionPessoa.pessoaTitle")
              }}</strong>
              <a class="ml-auto btn btn-primary" href="/#/pessoa/novo">
                {{ $t("btAdicionar") }}
              </a>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                <div class="form-group">
                  <label for>{{ $t("sectionPessoa.pessoaNome") }}</label>
                  <input
                    v-model="filtro.nome"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                <div class="form-group">
                  <label for>{{ $t("sectionPessoa.pessoaCpf") }}</label>
                  <input
                    v-model="filtro.documento"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                <div class="form-group">
                  <label for>{{ $t("textIdentificacao") }}</label>
                  <input
                    v-model="filtro.telefone"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2">
                <div class="form-group">
                  <label>{{ $t("sectionPessoa.pessoaCep") }}</label>
                  <input
                    v-model="filtro.cep"
                    type="number"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div class="form-group">
                  <label>{{ $t("sectionPessoa.pessoaRua") }}</label>
                  <input
                    v-model="filtro.rua"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-sm-6 col-md-2 col-lg-2 col-xl-1">
                <label for>{{ $t("sectionPessoa.pessoaStatusAtivo") }}</label>
                <b-form-checkbox
                  v-model="filtro.ativo"
                  name="check-button"
                  switch
                >
                  {{ $t("sectionPessoa.pessoaStatusAtivoSim") }}
                </b-form-checkbox>
              </div>
              <div class="col-sm-6 col-md-1 col-lg-1 col-xl-1">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="Filtrar()"
                >
                  {{ $t("btFiltrar") }}
                </button>
              </div>
              <div class="col-sm-6 col-md-1 col-lg-1 col-xl-1">
                <button
                  class="btn btn-secondary"
                  type="button"
                  @click="Limpar()"
                >
                  {{ $t("btLimpar") }}
                </button>
              </div>
            </div>

            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              :per-page="itensPorPagina"
              show-empty
              :empty-text="$t('textNenhumResultado')"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>              
              <template v-slot:cell(tipoContato)="data">
                <div class="center">
                  <span class="badge">{{ ObterTipoNome(data.item.tipoContato) }}</span>
                </div>
              </template>
              <template v-slot:cell(ativo)="data">
                <div class="center">
                  <span v-if="data.item.ativo" class="badge badge-success">
                    Sim
                  </span>
                  <span v-else class="badge badge-secondary">Não</span>
                </div>
              </template>
              <template v-slot:cell(acoes)="data">
                <div class="btn-group-sm">
                  <b-button
                    variant="warning"
                    style="margin-right: 10px;"
                    :title="$t('btEditar')"
                    @click="Editar(data.item,data.item.tipoContato)"
                  >
                    <i class="fa fa-edit text-black"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    :title="$t('btRemover')"
                    @click="Remover(data.item)"
                  >
                    <i class="fas fa-trash-alt text-black"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="total"
              :per-page="itensPorPagina"
              align="right"
              size="md"
              class="mt-2"
            ></b-pagination>
            <b-modal
              v-model="modalRemover"
              :title="$t('textConfirmaExclusaoAfirmacao')"
              header-bg-variant="danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              {{ $t("infoMessages.confirmTheDeletionOfThisRecord") }}
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import TipoAtendimento from "../../enums/TipoAtendimento";
export default {
  name: "Pessoa",
  components: {
    RotateSquare
  },
  data() {
    return {
      locale: this.$i18n.locale,
      modalRemover: false,
      itemRemover: null,
      loading: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 0,
      filtro: {
        nome: "",
        ativo: true,
        cep: "",
        rua: "",
        documento: "",
        telefone: "",
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        pagina: 1
      }
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "nome",
          label: this.$t("sectionPessoa.pessoaNome"),
          sortable: true
        },
        { key: "telefone", label: this.$t("textIdentificacao"), sortable: true },        
        {
          key: "tipoContato",
          label: this.$t("sectionAtendimento.atendimentoTipo"),
          sortable: true
        },
        {
          key: "ativo",
          label: this.$t("sectionPessoa.pessoaStatusAtivo"),
          sortable: true
        },
        {
          key: "acoes",
          label: this.$t("sectionAtendimento.atendimentoAcoes"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ];
    }
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    },
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  beforeMount() {
    this.ObterGrid(1);
  },
  methods: {
    Limpar() {
      this.filtro.nome = "";
      this.filtro.ativo = true;
      this.filtro.cep = "";
      this.filtro.rua = "";
      this.filtro.documento = "";
      this.filtro.telefone = "";
      this.ObterGrid(1);
    },
    ObterTipoNome(tipo) {
      switch (tipo) {
        case 0:
        case 3:
          return "WhatsApp";
        case 2:
          return "Facebook";
        case 1:
          return "Instagram";
        default:
          return "";
      }
    },
    Filtrar() {
      this.ObterGrid(1);
    },
    Editar(usuario,tipoContato) {
      this.$router.push("/pessoa/editar/" + usuario.id + "/" + tipoContato);
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      this.$http({
        url:
          "pessoa/remover/" +
          this.itemRemover.id +
          "/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "DELETE"
      })
        .then(() => {
          this.ObterGrid(1);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    ObterGrid(pagina) {
      this.loading = true;
      this.filtro.pagina = pagina;
      this.$http({
        url: "/pessoa/obter-grid/",
        data: this.filtro,
        method: "POST"
      })
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>
<style>
.margin-top-filter-button {
  margin-top: 29px;
}
</style>
